import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { getRefundMethodFieldId } from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/helpers'

import { extraStoreCreditOptions, extraStoreCreditTypes, labelValuesByExtraStoreCreditOption } from './constants'
import * as Styles from './styles'

const ExtraAmountSelector = ({
  value,
  onChange,
  extraValue,
  handleExtraValue,
  maxExtraAmount,
  handleMaxExtraAmount,
  minEligibleRefundAmount,
  handleMinEligibleRefundAmount,
  storeCurrencySymbol,
  disabled,
  errors,
  refundMethodName,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Crédito adicional')}</Text>
      <Text type="bodyMRegular">
        {t('Es posible añadir crédito adicional al reembolso para incentivar su selección en el Portal.')}
      </Text>
      <div>
        <ComboBox
          fullWidth
          label={t('Tipo crédito')}
          value={value}
          handleChange={onChange}
          disabled={disabled}
          backgroundColor={theme.colors.background.primary}
          menuItems={extraStoreCreditOptions.map(option => ({ label: t(option.label), value: option.value }))}
        />
      </div>
      <div>
        {[extraStoreCreditTypes.fixedAmount, extraStoreCreditTypes.percentage].includes(value) && (
          <Styles.FieldContainer id={getRefundMethodFieldId(refundMethodName, 'extra_value')}>
            <InputWithLabel
              label={t(labelValuesByExtraStoreCreditOption[value])}
              value={extraValue}
              onChange={handleExtraValue}
              type="number"
              startAdornment={value === extraStoreCreditTypes.fixedAmount ? storeCurrencySymbol : '%'}
              fullWidth
              disabled={disabled}
              backgroundColor={theme.colors.background.primary}
              error={Boolean(errors?.extra_value)}
              helperText={errors?.extra_value ? t('Este campo es obligatorio') : undefined}
            />
          </Styles.FieldContainer>
        )}
        {value === extraStoreCreditTypes.percentage && (
          <Styles.FieldContainer id={getRefundMethodFieldId(refundMethodName, 'max_extra_amount')}>
            <InputWithLabel
              label={t('Máximo crédito adicional')}
              value={maxExtraAmount?.toString()}
              type="number"
              onChange={handleMaxExtraAmount}
              startAdornment={storeCurrencySymbol}
              fullWidth
              disabled={disabled}
              backgroundColor={theme.colors.background.primary}
              error={Boolean(errors?.max_extra_amount)}
              helperText={errors?.max_extra_amount ? t('Este campo es obligatorio') : undefined}
            />
          </Styles.FieldContainer>
        )}
        {value === extraStoreCreditTypes.fixedAmount && (
          <Styles.FieldContainer id={getRefundMethodFieldId(refundMethodName, 'min_eligible_refund_amount')}>
            <InputWithLabel
              label={t('Mínimo reembolso aplicable')}
              value={minEligibleRefundAmount?.toString()}
              type="number"
              onChange={handleMinEligibleRefundAmount}
              startAdornment={storeCurrencySymbol}
              fullWidth
              disabled={disabled}
              backgroundColor={theme.colors.background.primary}
              error={Boolean(errors?.min_eligible_refund_amount)}
              helperText={errors?.min_eligible_refund_amount ? t('Este campo es obligatorio') : undefined}
            />
          </Styles.FieldContainer>
        )}
      </div>
    </Styles.Container>
  )
}

export default ExtraAmountSelector
